import type { SetupCompletionResult, SetupCompletionPayload } from '../../../types'
import type { Translator } from './types'
import { sanitizeSetupErrorMessage } from './errors'
import { executeCsrfProtectedSetupPost } from './csrf'
import { toResponseError, toSetupCompletionResult } from './payloads'

export const requestSetupCompletion = async ({
  payload,
  t,
}: {
  payload: SetupCompletionPayload
  t: Translator
}): Promise<SetupCompletionResult> => {
  const { response, raw, data } = await executeCsrfProtectedSetupPost({
    path: '/setup/complete',
    payload,
    fallbackError: t('setup.toast.completeError'),
  })

  if (!response.ok) {
    const message = toResponseError({
      raw,
      data,
      fallback: t('setup.toast.statusError', { status: response.status }),
    })
    throw new Error(sanitizeSetupErrorMessage({ message, t }))
  }

  return toSetupCompletionResult({ data })
}
